import React from "react";
import ReactDOM from "react-dom";

export default function Navbar() {
  return (
    <div className="nav-box">
      <nav>
        <img className="logo" src="airbnb-logo.png" alt="airbnb logo" />
      </nav>
    </div>
  );
}
